import { RestHandler } from 'msw';
import { postArchiveDataHandler } from './archiveHandler';
import {
  paymentApprovalsHandler,
  authorizedApCheckHandler,
  deleteApprovalHandler
} from './authorizedApCheckHandler';
import { authorizedPaymentHandler } from './authorizedPaymentHandler';
import { cashInBankInterCompanyHandler } from './cashInBankInterCompanyHandler';
import { printerAndCheckNoHandler } from './checkSequenceHandler';
import { checkWritingHandler } from './checkWritingHandler';
import { glCalendarHandler } from './glCalendarHandler';
import { glPostingValidationHandler } from './glPostingValidationHandler';
import { highVolumePrintCheckDataHandler } from './highVolumePrintCheckDataHandler';
import { highVolumeVendorsTableHandler } from './highVolumeVendorsTableHandler';
import { updateInvoiceStateHandler } from './invoiceStateHandler';
import {
  fetchInvoiceLockStatusHandler,
  updateInvoiceLockStatusHandler
} from './lockInvoiceHandler';
import { pdfGenerationHandler } from './pdfGenerationHandler';
import { printChecksCIBDropdownHandler } from './printChecksCIBDropdownHandler';
import { printChecksTableHandler } from './printChecksTableHandler';
import { postPrintDataHandler, printerListHandler } from './printerHandler';
import { reconciliationReportHandler } from './reconciliationReportHandler';
import { testHandler } from './testHandler';
import { updateInvoiceDescriptionHandler } from './updateInvoiceDescriptionHandler';
import { userDataHandler } from './userDataHandler';
import { vendorsTableHandler } from './vendorsTableHandler';
import { voidVCCPaymentHandler } from './voidVCCPaymentHandler';

export const handlers: RestHandler[] = [
  ...paymentApprovalsHandler,
  ...authorizedPaymentHandler,
  ...glPostingValidationHandler,
  ...authorizedApCheckHandler,
  ...checkWritingHandler,
  ...glCalendarHandler,
  ...deleteApprovalHandler,
  ...fetchInvoiceLockStatusHandler,
  ...cashInBankInterCompanyHandler,
  ...pdfGenerationHandler,
  ...postArchiveDataHandler,
  ...postPrintDataHandler,
  ...printChecksCIBDropdownHandler,
  ...printChecksTableHandler,
  ...printerListHandler,
  ...reconciliationReportHandler,
  ...testHandler,
  ...updateInvoiceDescriptionHandler,
  ...updateInvoiceLockStatusHandler,
  ...updateInvoiceStateHandler,
  ...userDataHandler,
  ...vendorsTableHandler,
  ...voidVCCPaymentHandler,
  ...highVolumeVendorsTableHandler,
  ...highVolumePrintCheckDataHandler,
  ...printerAndCheckNoHandler
];
